(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ba-slider]').forEach(function(wrap) {
  var before = wrap.querySelector('.ba__before');
  var line = wrap.querySelector('.ba__line');
  var knob = wrap.querySelector('.ba__knob');
  var active = false;

  function update(clientX) {
    var rect = wrap.getBoundingClientRect();
    var pct = Math.max(3, Math.min(97, ((clientX - rect.left) / rect.width) * 100));
    before.style.clipPath = 'inset(0 ' + (100 - pct).toFixed(2) + '% 0 0)';
    line.style.left = pct.toFixed(2) + '%';
    knob.style.left = pct.toFixed(2) + '%';
  }

  wrap.addEventListener('mousedown', function(e) {
    e.preventDefault();
    active = true;
    update(e.clientX);
  });
  window.addEventListener('mousemove', function(e) {
    if (active) update(e.clientX);
  });
  window.addEventListener('mouseup', function() { active = false; });
  wrap.addEventListener('touchstart', function(e) {
    active = true;
    update(e.touches[0].clientX);
  }, { passive: true });
  wrap.addEventListener('touchmove', function(e) {
    if (active) {
      e.preventDefault();
      update(e.touches[0].clientX);
    }
  }, { passive: false });
  window.addEventListener('touchend', function() { active = false; });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
const mobileToggle = document.querySelector('.header__mobile-toggle');
const mobileMenu = document.getElementById('mobile-menu');

if (mobileToggle && mobileMenu) {
  mobileToggle.addEventListener('click', () => {
    const open = mobileToggle.getAttribute('aria-expanded') === 'true';
    mobileToggle.setAttribute('aria-expanded', String(!open));
    mobileMenu.setAttribute('aria-hidden', String(open));
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
const sortSelect = document.querySelector('.main-collection__sort-select');
if (sortSelect) {
  sortSelect.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.href = url.toString();
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
// Star badge → smooth-scroll to the full Judge.me review widget. Bound on
// the wrapper (not Judge.me's own markup) so the app can re-render its badge
// freely; keyboard-activatable since the wrapper is a role=button.
document.querySelectorAll('.js-scroll-to-reviews').forEach((el) => {
  const scrollToReviews = (e) => {
    const target = document.getElementById('product-reviews');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  el.addEventListener('click', scrollToReviews);
  el.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') scrollToReviews(e);
  });
});

const slides = document.getElementById('product-slides');
const thumbs = document.querySelectorAll('.main-product__thumb');
const dots = document.querySelectorAll('.main-product__dot');

function goToSlide(index) {
  if (!slides) return;
  slides.scrollTo({ left: slides.offsetWidth * index, behavior: 'smooth' });
  thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
  dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
}

if (slides) {
  let scrollTimer;
  slides.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      const index = Math.round(slides.scrollLeft / slides.offsetWidth);
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    }, 80);
  });

  let startX, startScroll, dragging = false;
  slides.addEventListener('mousedown', e => { startX = e.pageX; startScroll = slides.scrollLeft; dragging = true; slides.classList.add('is-dragging'); document.body.style.userSelect = 'none'; });
  document.addEventListener('mousemove', e => { if (!dragging) return; slides.scrollLeft = startScroll - (e.pageX - startX); });
  document.addEventListener('mouseup', () => { if (!dragging) return; dragging = false; slides.classList.remove('is-dragging'); document.body.style.userSelect = ''; });
}

thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => goToSlide(index)));
dots.forEach((dot, index) => dot.addEventListener('click', () => goToSlide(index)));

const qtyInput = document.querySelector('.main-product__qty-input');
document.querySelectorAll('.main-product__qty-btn').forEach((btn, i) => {
  btn.addEventListener('click', () => {
    if (!qtyInput) return;
    const val = parseInt(qtyInput.value) || 1;
    qtyInput.value = i === 0 ? Math.max(1, val - 1) : val + 1;
  });
});

// ── "Choose your wash" purchase-option selector (bottle pages only).
// The radios swap the ONE product form's hidden variant id, so the theme's
// single delegated /cart/add handler (cart drawer) performs the add with all
// of its existing AJAX, loading, error, and cart-count behavior for BOTH
// options — no second form, no duplicate submit logic. Quantity is the same
// shared input, so it applies to whichever option is selected. The sticky
// mobile bar mirrors the selection (it reuses the real ATC button's click).
const buyopt = document.querySelector('[data-buyopt]');
if (buyopt) {
  const productForm = document.getElementById('product-form');
  const idInput = productForm ? productForm.querySelector('input[name="id"]') : null;
  const atcBtn = document.querySelector('.main-product__atc');
  const stickyTitle = document.querySelector('.sticky-atc__title');
  const stickyPrice = document.querySelector('.sticky-atc__price');
  const stickyBtn = document.querySelector('[data-sticky-atc-btn]');
  const soldOutLabel = buyopt.dataset.soldoutLabel || 'Sold out';

  const applyOption = (input) => {
    if (!input || !idInput) return;
    idInput.value = input.dataset.variantId;
    const available = input.dataset.available === 'true';
    const label = available ? input.dataset.atcLabel : soldOutLabel;
    [atcBtn, stickyBtn].forEach((b) => {
      if (!b) return;
      b.disabled = !available;
      b.textContent = label;
      b.setAttribute('aria-label', label);
    });
    if (stickyTitle) stickyTitle.textContent = input.dataset.title;
    if (stickyPrice) stickyPrice.textContent = input.dataset.priceLabel;
    const availEl = document.querySelector('[data-availability]');
    if (availEl) {
      const availText = availEl.querySelector('[data-availability-text]');
      const ship = availEl.dataset.shipLabel;
      availEl.classList.toggle('main-product__availability--out', !available);
      if (availText) {
        availText.textContent = available
          ? availEl.dataset.instockLabel + (ship ? ' · ' + ship : '')
          : availEl.dataset.outLabel;
      }
    }
    // analytics hook: no library added — a documented DOM event any pixel
    // or data layer can subscribe to
    document.dispatchEvent(new CustomEvent('seife:purchase-option-selected', {
      detail: { option: input.value, variantId: input.dataset.variantId }
    }));
  };

  buyopt.addEventListener('change', (e) => {
    if (e.target && e.target.classList.contains('main-product__buyopt-input')) applyOption(e.target);
  });

  // analytics hook: fires alongside (never instead of) the theme's global
  // add-to-cart handler; reports which option the shopper actually added
  if (productForm) {
    productForm.addEventListener('submit', () => {
      const selected = buyopt.querySelector('.main-product__buyopt-input:checked');
      document.dispatchEvent(new CustomEvent('seife:add-to-cart', {
        detail: {
          option: selected ? selected.value : 'individual',
          variantId: idInput ? idInput.value : null,
          quantity: parseInt(qtyInput && qtyInput.value) || 1
        }
      }));
    });
  }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
// Dynamic sort icon for the Judge.me compact sort control: the visible glyph
// (the SVG inside .jm-sort-filter__icon--sort) reflects the currently
// selected sort option instead of the app's fixed up/down arrows. The native
// <select> stays the source of truth and is never rebuilt; we only rewrite
// the path data of the app's own single SVG (no stacked icons) and keep the
// select's accessible name in sync ("Sort reviews: <option>"). A delegated
// change listener plus a MutationObserver survive Judge.me's Vue rerenders
// without ever binding twice (window flag) or duplicating SVGs (the icon is
// rewritten in place, keyed by a data attribute).
(function () {
  if (window.__seifeSortIcon) return;
  window.__seifeSortIcon = true;

  var WIDGET = '#judgeme_product_reviews';
  // 16x16, fill: currentColor. Keys are Judge.me's own option values.
  var ICONS = {
    // Most recent: clock
    created_at: '<path fill-rule="evenodd" d="M8 1.25a6.75 6.75 0 1 1 0 13.5 6.75 6.75 0 0 1 0-13.5Zm0 1.5a5.25 5.25 0 1 0 0 10.5A5.25 5.25 0 0 0 8 2.75Zm.75 1.75v3.19l2.47 1.43-.75 1.3L7.25 8.5V4.5h1.5Z"/>',
    // Highest rating: star + up arrow
    highest_rating: '<path d="M5.2 2.2l1 2.2 2.4.3-1.8 1.6.5 2.4-2.1-1.2-2.1 1.2.5-2.4-1.8-1.6 2.4-.3ZM12 6.4 14.6 9h-1.85v4.6h-1.5V9H9.4Z"/>',
    // Lowest rating: star + down arrow
    lowest_rating: '<path d="M5.2 2.2l1 2.2 2.4.3-1.8 1.6.5 2.4-2.1-1.2-2.1 1.2.5-2.4-1.8-1.6 2.4-.3ZM12 13.6 9.4 11h1.85V6.4h1.5V11h1.85Z"/>',
    // Only pictures: image
    with_pictures: '<path fill-rule="evenodd" d="M2 3.25h12c.41 0 .75.34.75.75v8c0 .41-.34.75-.75.75H2A.75.75 0 0 1 1.25 12V4c0-.41.34-.75.75-.75Zm.75 1.5v6.5h10.5v-6.5H2.75Zm2.5 1a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2ZM4.4 10.4l2.1-2.5 1.5 1.6 1.9-2.4 1.9 3.3H4.4Z"/>',
    // Pictures first: small image + up arrow
    pictures_first: '<path fill-rule="evenodd" d="M1.5 6.25h8c.41 0 .75.34.75.75v6c0 .41-.34.75-.75.75h-8A.75.75 0 0 1 .75 13V7c0-.41.34-.75.75-.75Zm.75 1.5v4.5h6.5v-4.5H2.25Zm1.5.9a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8Zm-.65 2.85 1.3-1.55.95 1 1.15-1.45 1.3 2H3.1ZM12.6 2 15 4.4h-1.65v4.1h-1.5V4.4H10.2Z"/>',
    // Videos first: video frame with play triangle
    videos_first: '<path fill-rule="evenodd" d="M2 3.75h12c.41 0 .75.34.75.75v7c0 .41-.34.75-.75.75H2a.75.75 0 0 1-.75-.75v-7c0-.41.34-.75.75-.75Zm.75 1.5v5.5h10.5v-5.5H2.75Zm3.75.9 4 1.85-4 1.85v-3.7Z"/>',
    // Most helpful: thumbs up
    most_helpful: '<path d="M2.25 7h2.5v6.75h-2.5V7Zm3.75 6.75V7.3l2.35-4.8c.92.02 1.65.77 1.65 1.69V6.5h2.9c.85 0 1.5.75 1.38 1.59l-.55 3.9a1.75 1.75 0 0 1-1.73 1.51H6Z"/>'
  };

  function apply() {
    var widget = document.querySelector(WIDGET);
    if (!widget) return;
    var sel = widget.querySelector('.jm-sort-filter--compact select');
    var iconSpan = widget.querySelector('.jm-sort-filter--compact .jm-sort-filter__icon--sort');
    if (!sel || !iconSpan) return;
    var svg = iconSpan.querySelector('svg');
    if (!svg) return;
    var v = ICONS[sel.value] ? sel.value : 'created_at';
    if (svg.getAttribute('data-seife-sort-icon') !== v) {
      svg.setAttribute('viewBox', '0 0 16 16');
      svg.setAttribute('fill', 'currentColor');
      svg.setAttribute('aria-hidden', 'true');
      svg.innerHTML = ICONS[v];
      svg.setAttribute('data-seife-sort-icon', v);
    }
    var opt = sel.options[sel.selectedIndex];
    if (opt) {
      var label = 'Sort reviews: ' + opt.text;
      if (sel.getAttribute('aria-label') !== label) sel.setAttribute('aria-label', label);
    }
  }

  // one delegated listener at document level: survives widget rerenders and
  // cannot double-bind
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches(WIDGET + ' .jm-sort-filter--compact select')) apply();
  }, true);

  // Vue rerenders replace the control's DOM (fresh SVG with the app's
  // default arrows) — reapply on childList changes. apply() is cheap and
  // self-guarded, so observer feedback settles after one pass.
  var observer = new MutationObserver(apply);
  function boot() {
    var widget = document.querySelector(WIDGET);
    if (widget) {
      observer.observe(widget, { childList: true, subtree: true });
      apply();
    } else {
      setTimeout(boot, 500);
    }
  }
  boot();
})();

  } catch(e) { console.error(e); }
})();
})();
